import { put, call, takeLatest } from 'redux-saga/effects'

import {
  getTags as getTagsApi,
  createTag as createTagApi,
  getTagMappingsSearch as getTagMappingsApi,
} from 'Service/Api'

import * as TagTypes from 'Redux/Types/TagTypes'
import * as TagActions from 'Redux/Actions/TagActions'

function* getTags() {
  try {
    const { data } = yield call(getTagsApi, 'tag')
    yield put(TagActions.getTagsSucceeded(data))
  } catch (errors) {
    yield put(TagActions.getTagsFailed(errors))
  }
}

function* createTag({ payload }) {
  const params = { value: payload, type: { name: 'tag' } }
  try {
    const { data } = yield call(createTagApi, params)
    yield put(TagActions.createTagSucceeded(data))
  } catch (errors) {
    yield put(TagActions.createTagFailed(errors))
  }
}

function* getTagMappings() {
  const params = { type: { name: 'expensecategory' }, includeTagMappings: true }
  try {
    const { data } = yield call(getTagMappingsApi, params)
    yield put(TagActions.getTagMappingsSucceeded(data))
  } catch (errors) {
    yield put(TagActions.getTagMappingsFailed(errors))
  }
}

export default function* tagSaga() {
  yield takeLatest(TagTypes.GET_TAGS, getTags)
  yield takeLatest(TagTypes.CREATE_TAG, createTag)
  yield takeLatest(TagTypes.GET_TAG_MAPPINGS, getTagMappings)
}
